<template>
  <div class="animated fadeIn">
    <Row>
      <Input search @on-search="onFilterClick" size="small" clearable v-model="keywordFilter" placeholder="设备名称"
             style="width: 200px; margin-right: 3px;"></Input>
      <Button size="small" type="primary" style="margin-right: 3px;" @click="onFilterClick">查询</Button>
      <Button size="small" type="primary" style="margin-right: 3px;" @click="addPositioningDeviceFittingsTypeModal=true">
        添加配件类型
      </Button>
    </Row>
    <Row style="margin-top: 3px;">
      <div style="width: 100%;">
        <div style="position:relative;">
          <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
          <Table border highlight-row size="small" height="600" :columns="columns" :stripe="true" :data="content"
                 ref="table" :height="tableHeight"
                 @on-sort-change="sortChange" @on-filter-change="filterChange"
                 @contextmenu.prevent.native="onTableRightClick($event)"></Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true" show-elevator
              @on-change="setPage"
              show-sizer @on-page-size-change="refreshPage" :page-size-opts="pagesizeopts"
              style="text-align:right;margin-top:3px;"></Page>

      </div>
    </Row>
<!--  添加设备类型图片组件  -->
    <positioning-device-fittings-type-picture-modal v-model="positioningDeviceFittingsTypePictureModal" :initValue="positioningDeviceFittingsTypePictureModalId"></positioning-device-fittings-type-picture-modal>
<!--  添加设备配件类型组件  -->
    <add-positioning-device-fittings-type-modal v-model="addPositioningDeviceFittingsTypeModal" @on-success="onSuccess"></add-positioning-device-fittings-type-modal>
<!--  修改设备配件类型组件  -->
    <modif-positioning-device-fittings-type-modal v-model="modifPositioningDeviceTypeModal" :initValue="modifPositioningDeviceTypeModalId"
                                         @on-success="refreshPage"></modif-positioning-device-fittings-type-modal>
<!--  配件类型备注组件  -->
    <positioning-device-fittings-type-add-processremark-modal v-model="positioningDeviceFittingsTypeAddProcessremarkModal" :initValue="positioningDeviceFittingsTypeAddProcessremarkId"
                                                     @on-success="refreshPage"></positioning-device-fittings-type-add-processremark-modal>
<!--  表格右击设置组件  -->
    <web-table-columns-modal :columnList.sync="columns" :tableName="$options.name"
                             v-model="webTableColumnsModal"></web-table-columns-modal>
  </div>
</template>

<script>
import PositioningDeviceFittingsTypePictureModal from '@/view/im/components/positioning-device-fittings-type-picture-modal'
import AddPositioningDeviceFittingsTypeModal from '@/view/im/components/add-positioning-device-fittings-type-modal'
import ModifPositioningDeviceFittingsTypeModal from '@/view/im/components/modif-positioning-device-fittings-type-modal'
import PositioningDeviceFittingsTypeAddProcessremarkModal from '@/view/im/components/positioning-device-fittings-type-add-processremark-modal'

import Vue from 'vue'
import store from '@/store'
import { mapActions } from 'vuex'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'positioningdevicefittingstype',
  components: {
    PositioningDeviceFittingsTypePictureModal,
    AddPositioningDeviceFittingsTypeModal,
    ModifPositioningDeviceFittingsTypeModal,
    PositioningDeviceFittingsTypeAddProcessremarkModal
  },
  data () {
    return {
      // 添加设备类型图片组件
      positioningDeviceFittingsTypePictureModal: false,
      positioningDeviceFittingsTypePictureModalId: null,
      // 添加定位设备类型组件
      addPositioningDeviceFittingsTypeModal: false,
      // 修改定位设备类型组件
      modifPositioningDeviceTypeModal: false,
      modifPositioningDeviceTypeModalId: null,
      // 追加备注
      positioningDeviceFittingsTypeAddProcessremarkModal: false,
      positioningDeviceFittingsTypeAddProcessremarkId: null,

      // 关键字搜索
      keywordFilter: null,
      // 根据生产商筛选
      manufacturerFilter: null,
      // 表格及分页样式
      pageFilter: 30,
      pagesizeopts: [30, 50, 100, 200],
      tableHeight: 160,
      pageIndex: 1,
      sort: null,
      listLoadding: false,

      // 配件类型筛选
      positioningDeviceFittingsModelFilter: null,

      //  右击设置表格
      webTableColumnsModal: false,
      menuList: [
        { title: '设置表格列', content: {} }
      ],

      // table表头
      columns: [
        {
          title: 'ID',
          resizable: true,
          key: 'id',
          sortable: 'custom',
          tooltip: 'true',
          width: 100
        },
        {
          title: '配件型号/名称',
          resizable: true,
          key: 'name',
          ellipsis: 'true',
          width: 180
        },
        {
          title: '配件类型',
          resizable: true,
          key: 'positioningDeviceFittingFirstOrderTypeId',
          ellipsis: 'true',
          width: 180,
          filters: [
            { label: '摄像头', value: 1 },
            { label: '显示屏', value: 2 },
            { label: '延长线', value: 3 },
            { label: '硬盘', value: 4 },
            { label: '声光报警', value: 5 },
            { label: '对讲机', value: 6 },
            { label: '喇叭', value: 7 },
            { label: '天线', value: 8 },
            { label: '电源线', value: 9 }
          ],
          filterMultiple: false,
          filterRemote: (val) => {
            if (val.length > 0) {
              this.positioningDeviceFittingsModelFilter = genQueryParam('type', 'EQ', val[0])
            } else {
              this.positioningDeviceFittingsModelFilter = null
            }
          },
          render: function (h, params) {
            let type = params.row.positioningDeviceFittingFirstOrderTypeId
            if (type == 1) {
              return h('div', '摄像头')
            } else if (type == 2) {
              return h('div', '显示屏')
            } else if (type == 3) {
              return h('div', '延长线')
            } else if (type == 4) {
              return h('div', '硬盘')
            } else if (type == 5) {
              return h('div', '声光报警')
            } else if (type == 6) {
              return h('div', '对讲机')
            } else if (type == 7) {
              return h('div', '喇叭')
            } else if (type == 8) {
              return h('div', '天线')
            } else if (type == 9) {
              return h('div', '电源线')
            } else {
              return h('div', '未知')
            }
          }
        },
        {
          title: '设备生产商型号',
          resizable: true,
          key: 'manufacturername',
          ellipsis: 'true',
          width: 180
        },
        {
          title: '设备生产商',
          resizable: true,
          key: 'manufacturer',
          ellipsis: 'true',
          sortable: 'custom',
          width: 180
        },
        {
          title: '设备参数',
          resizable: true,
          key: 'parameter',
          ellipsis: 'true',
          tooltip: 'true',
          width: 180
        },
        {
          title: '更新时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'updateDatetime',
          width: 180,
          render: function (h, params) {
            if (params.row.updateDatetime) {
              let d = new Date(params.row.updateDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '创建时间',
          resizable: true,
          sortable: 'custom',
          ellipsis: 'true',
          tooltip: 'true',
          key: 'createDatetime',
          width: 180,
          render: function (h, params) {
            if (params.row.createDatetime) {
              let d = new Date(params.row.createDatetime)
              return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
            }
          }
        },
        {
          title: '备注',
          resizable: true,
          key: 'remark',
          ellipsis: 'true',
          tooltip: 'true',
          minWidth: 100
        },
        {
          title: '操作',
          resizable: true,
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          width: 250,
          fixed: 'right',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.positioningDeviceFittingsTypePictureModalId = params.row.id
                    this.positioningDeviceFittingsTypePictureModal = true
                  }
                }
              }, '设备图片'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.modifPositioningDeviceTypeModalId = params.row.id
                    this.modifPositioningDeviceTypeModal = true
                  }
                }
              }, '修改'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.positioningDeviceFittingsTypeAddProcessremarkId = params.row.id
                    this.positioningDeviceFittingsTypeAddProcessremarkModal = true
                  }
                }
              }, '追加备注'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '删除设备类型',
                      content: '<p>是否确认删除此配件类型</p>',
                      onOk: () => {
                        store.dispatch('PositioningDeviceFittingsTypeServ_DeleteObj', { params: { id: params.row.id } }).then(() => {
                          this.$Message.success('删除成功')
                          this.refreshPage()
                        }).catch(err => {
                          this.$Message.error(err)
                        })
                      },
                      onCancel: () => {
                      }
                    })
                  }
                }
              }, '删除')
            ])
          }
        }
      ]// cloumn
    }
  },
  methods: {
    onFilterClick () {
      this.setPage(1)
    },
    // 表格排序
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage()
    },
    filterChange () {
      this.refreshPage()
    },
    // 刷新当前页
    refreshPage (value) {
      this.pageFilter = value
      this.setPage(this.pageIndex)
    },
    onSuccess () {
      this.setPage(1)
    },
    setPage (page) {
      console.log('setPage' + page)
      this.pageIndex = page
      this.listLoadding = true

      let qo1 = null
      let qo2 = null
      let queryParams = []
      let sortParam = null

      if (this.sort) {
        sortParam = genSortParam(this.sort.name, this.sort.asc)
      }

      if (this.manufacturerFilter) {
        qo1 = this.manufacturerFilter
      }
      if (this.positioningDeviceFittingsModelFilter) {
        qo2 = this.positioningDeviceFittingsModelFilter
      }

      store.dispatch('PositioningDeviceFittingsTypeServ_GetPage', {
        params: null,
        urlparams: {
          q: queryParams,
          qo1: qo1,
          qo2: qo2,
          ps: this.pageFilter,
          p: page,
          keyword: this.keywordFilter,
          sort: sortParam
        }
      }).then(() => {
        this.listLoadding = false
      }).catch(err => {
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    /**
         * 右键菜单点击回调
         */
    onContextMenuCallback (item) {
      if (item.title === '设置表格列') {
        this.webTableColumnsModal = true
      }
    }
  },
  /**
       * 表格右键回调
       */
  onTableRightClick (e) {
    this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
  },
  computed: {
    totalElements () {
      if (store.getters.get_PositioningDeviceFittingsType_GetPageResult) {
        return store.getters.get_PositioningDeviceFittingsType_GetPageResult.totalElements
      } else {
        return 0
      }
    },
    content () {
      if (store.getters.get_PositioningDeviceFittingsType_GetPageResult) {
        return store.getters.get_PositioningDeviceFittingsType_GetPageResult.content
      } else {
        return []
      }
    },
    pageSize () {
      if (store.getters.get_PositioningDeviceFittingsType_GetPageResult) {
        return store.getters.get_PositioningDeviceFittingsType_GetPageResult.size
      } else {
        return 0
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      window.onresize = () => {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
      }
      this.setPage(1)
    })
  }
}
</script>

<style scoped>

</style>
